<template>
  <div>
    <el-steps :active="step" finish-status="success" class="steps">
      <el-step title="企业基本信息"></el-step>
      <el-step title="专职专业人员信息"></el-step>
      <el-step title="业绩信息"></el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  name: "Step",
  props: {
    step: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      active: 0,
    };
  },
  methods: {
    next() {
      if (this.active++ > 2) this.active = 0;
    },
  },
};
</script>

<style lang="less" scoped>
.steps {
  /deep/ .el-step__title.is-process {
    font-size: 14px;
    font-weight: 700;
    color: #333333;
  }

  /deep/ .el-step__title.is-wait {
    color: #666666;
    font-size: 14px;
  }
}
</style>
